import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { isPushSupported, getPushPermission, initPushNotifications } from "../../Utils/pushService";
import "./PushPrompt.css";

const STORAGE_KEY = "dora_push_dismissed";

const PushPrompt = () => {
  const { token } = useAuth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!token) return;
    if (!isPushSupported()) return;
    if (getPushPermission() !== "default") return;
    if (localStorage.getItem(STORAGE_KEY)) return;

    // Show after a short delay so it doesn't flash on page load
    const timer = setTimeout(() => setShow(true), 5000);
    return () => clearTimeout(timer);
  }, [token]);

  const handleEnable = async () => {
    setShow(false);
    await initPushNotifications();
  };

  const handleDismiss = () => {
    setShow(false);
    localStorage.setItem(STORAGE_KEY, "1");
  };

  if (!show) return null;

  return (
    <div className="push-prompt" role="alert">
      <p className="push-prompt-text">
        Get notified when your order status changes!
      </p>
      <div className="push-prompt-actions">
        <button className="push-prompt-enable" onClick={handleEnable}>
          Enable Notifications
        </button>
        <button className="push-prompt-dismiss" onClick={handleDismiss}>
          Not now
        </button>
      </div>
    </div>
  );
};

export default PushPrompt;
